import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TeamLogoTypes } from '@mlb/react-patterns/components/TeamLogo/teamLogo.types';
import Team from '@mlb/react-patterns/components/Team/team';
import StandingText from '../../TeamSummaryMatchup/StandingText';
import { useTeamUrl } from '@gameday/utils/hooks/useTeamUrl';

import useTracking from '@gameday/utils/hooks/useTracking';

const logoType = TeamLogoTypes.SPOT;

const psLogosMap = {
    103: 159,
    104: 160
};

const TeamComponent = ({
    team,
    isAway = false,
    standings = {},
    isMobile,
    logoSize,
    deviceInteraction
}) => {
    const Tracking = useTracking();
    const {
        teamName,
        abbreviation,
        id,
        league,
        placeholder,
        record: {
            leagueRecord: {
                wins,
                losses
            } = {}
        } = {}
    } = team || {};

    const { divisionRank = '', nameShort = '' } = standings;
    const convertedId = placeholder && psLogosMap?.[league?.id];
    const teamUrl = useTeamUrl(id);

    const handleClubPage = useCallback((e, id) => {
        const cfg = {
            componentName: ['Preview', 'Preview Info'],
            text: e.currentTarget.innerText,
            activity: 'Team Logo Link Click'
        };

        Tracking.track.track_click(cfg);

        if (deviceInteraction?.team({ teamId: id })) {
            e.preventDefault();
        }
    }, [Tracking, deviceInteraction]);

    const linkProps = useMemo(() => {
        return {
            href: teamUrl || undefined,
            target: '_blank',
            handlers: {
                onClick: (e) => handleClubPage(e, id)
            },
            ariaLabel: teamName
        };
    }, [id, teamUrl, Tracking, teamName]);

    return (
        <Team
            name={ isMobile ? abbreviation : teamName }
            logoSize={ logoSize }
            teamId={ convertedId || id }
            leftAligned={ isAway }
            wins={ wins }
            losses={ losses }
            standingsText={ isMobile ? undefined : <StandingText nameShort={nameShort} divisionRank={divisionRank}/> }
            teamLogoType={ logoType }
            linkProps={linkProps}
        />
    );
};

TeamComponent.propTypes = {
    team: PropTypes.object,
    isAway: PropTypes.bool,
    standings: PropTypes.object,
    isMobile: PropTypes.bool,
    logoSize: PropTypes.string,
    deviceInteraction: PropTypes.object
};

export default TeamComponent;
